"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _styledComponents = require("styled-components");
var _styles = require("./styles");
var _excluded = ["children", "type", "reverse", "arrow", "disabled", "loading", "onClick", "icon", "iconSize", "iconRight", "iconRightSize", "size", "fontSize", "rounded", "align", "arrowStyle"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Icon = function Icon(_ref) {
  var component = _ref.component,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return component ? /*#__PURE__*/(0, _react.cloneElement)(component, {
    width: size,
    height: size
  }) : null;
};
var Button = function Button(_ref2) {
  var children = _ref2.children,
    type = _ref2.type,
    reverse = _ref2.reverse,
    arrow = _ref2.arrow,
    disabled = _ref2.disabled,
    loading = _ref2.loading,
    onClick = _ref2.onClick,
    icon = _ref2.icon,
    iconSize = _ref2.iconSize,
    iconRight = _ref2.iconRight,
    iconRightSize = _ref2.iconRightSize,
    size = _ref2.size,
    fontSize = _ref2.fontSize,
    rounded = _ref2.rounded,
    align = _ref2.align,
    arrowStyle = _ref2.arrowStyle,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var isIconPresent = icon || iconRight;
  var isMarginLeft = align === 'center' && !!(reverse ? icon : iconRight) || icon;
  var isMarginRight = align === 'center' && !!(reverse ? iconRight : icon) || iconRight;
  var body = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isIconPresent && /*#__PURE__*/_react["default"].createElement(_styles.IconWrapper, {
    position: "left",
    reverse: reverse,
    iconMargin: isMarginLeft
  }, !reverse ? /*#__PURE__*/_react["default"].createElement(Icon, {
    component: icon,
    size: iconSize
  }) : /*#__PURE__*/_react["default"].createElement(Icon, {
    component: iconRight,
    size: iconRightSize
  })), /*#__PURE__*/_react["default"].createElement(_styles.Body, {
    align: align
  }, reverse && arrow && /*#__PURE__*/_react["default"].createElement(_styles.Left, {
    arrowStyle: arrowStyle,
    align: align
  }), children, !reverse && arrow && /*#__PURE__*/_react["default"].createElement(_styles.Right, {
    arrowStyle: arrowStyle,
    align: align
  })), isIconPresent && /*#__PURE__*/_react["default"].createElement(_styles.IconWrapper, {
    position: "right",
    reverse: reverse,
    iconMargin: isMarginRight
  }, !reverse ? /*#__PURE__*/_react["default"].createElement(Icon, {
    component: iconRight,
    size: iconRightSize
  }) : /*#__PURE__*/_react["default"].createElement(Icon, {
    component: icon,
    size: iconSize
  })));
  var handleOnClick = function handleOnClick() {
    if (!disabled && !loading && (0, _isFunction["default"])(onClick)) {
      onClick();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_styles.ButtonStyle, _extends({
    ButtonStyle: true,
    onClick: handleOnClick,
    type: type,
    size: size,
    fontSize: fontSize,
    rounded: rounded
  }, _objectSpread({
    disabled: disabled
  }, rest)), !disabled && !loading && /*#__PURE__*/_react["default"].createElement(_styles.Ripple, _extends({
    colorType: rest.colorType
  }, rest)), loading ? /*#__PURE__*/_react["default"].createElement(_styles.Loader, _extends({
    colorType: rest.colorType
  }, rest)) : body);
};
Button.propTypes = {
  children: _propTypes["default"].node.isRequired,
  hover: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  reverse: _propTypes["default"].bool,
  arrow: _propTypes["default"].bool,
  arrowStyle: _propTypes["default"].object,
  loading: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  icon: _propTypes["default"].node,
  iconRight: _propTypes["default"].node,
  type: _propTypes["default"].string,
  size: _propTypes["default"].string,
  fontSize: _propTypes["default"].string,
  align: _propTypes["default"].string,
  rounded: _propTypes["default"].bool,
  uppercase: _propTypes["default"].bool
};
Button.defaultProps = {
  uppercase: true,
  arrow: true,
  hover: false,
  disabled: false,
  reverse: false,
  loading: false,
  size: 'l',
  fontSize: 's',
  rounded: false,
  align: 'center'
};
var _default = (0, _styledComponents.withTheme)(Button);
exports["default"] = _default;